import { render, staticRenderFns } from "./order-manager2.vue?vue&type=template&id=5100e270&scoped=true&"
import script from "./order-manager2.vue?vue&type=script&lang=js&"
export * from "./order-manager2.vue?vue&type=script&lang=js&"
import style0 from "./order-manager2.vue?vue&type=style&index=0&id=5100e270&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5100e270",
  null
  
)

export default component.exports